import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { RateLock } from "../../lib/models/rate-lock.model";
import { formatTimestampForRateLockSummary } from "../../lib/number-transforms";
import { ClockIcon } from "../icons/ClockIcon.tsx";

export type FormRateLockStatusProps = {
  rateLock: RateLock;
};
function FormRateLockStatus({ rateLock }: FormRateLockStatusProps) {
  return (
    <Box paddingBottom={2}>
      <Flex alignItems="center" color="gray.500" fontWeight="light">
        <ClockIcon mr={2} />
        <Text fontSize="xs">Rate Lock Status</Text>
      </Flex>
      <Box marginRight={2} display="inline">
        {rateLock?.rateLockActive ? (
          <Badge colorScheme="blue">Active</Badge>
        ) : (
          <Badge colorScheme="red">Expired</Badge>
        )}
      </Box>
      <Text
        fontWeight="medium"
        fontSize="sm"
        marginTop={1}
        textAlign="left"
        display="inline"
      >
        {rateLock?.startDate &&
          rateLock?.customerEndDate &&
          `${formatTimestampForRateLockSummary(
            rateLock.startDate
          )} - ${formatTimestampForRateLockSummary(rateLock.customerEndDate)}`}
      </Text>
    </Box>
  );
}
export default FormRateLockStatus;
